export const SHOW_MESSAGE = 'SHOW_MESSAGE'
export const SET_LOADING = 'SET_LOADING'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_MENU = 'SET_MENU'

// initial state
const state = {
  message: {
    visible: false,
    text: '',
    icon: '',
    color: ''
  },
  loading: false,
  error: null,
  menu: false
}

// getters
const getters = {
  message: state => state.message,
  loading: state => state.loading,
  error: state => state.error,
  menu: state => state.menu
}

// actions
const actions = {
  setMessage({ commit, dispatch }, message) {
    commit(SET_MESSAGE, message)
    dispatch('showMessage')
  },
  clearMessage({ commit }) {
    commit(CLEAR_MESSAGE)
  },
  clearError({ commit }) {
    commit('clearError')
  },
  showMessage({ commit }) {
    commit(SHOW_MESSAGE)
    setTimeout(() => {
      commit(CLEAR_MESSAGE)
    }, 10000)
  },
  setMainMenu({ commit }, status) {
    commit(SET_MENU, status)
  }
}

// mutations
const mutations = {
  [SET_MESSAGE](state, message) {
    state.message = message
  },
  [CLEAR_MESSAGE](state) {
    state.message.visible = false
    state.message.text = ''
    state.message.icon = ''
    state.message.color = ''
  },
  [SHOW_MESSAGE](state) {
    state.message.visible = true
  },
  [SET_MENU](state, status) {
    console.log('menu status',status)
    state.menu = status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js